import styled from 'styled-components'
import { MediaBreakpoint } from 'root-constants'

export const StyledVideo = {
  Container: styled.div`
    position: relative;
    max-width: ${MediaBreakpoint.MAX_PHONE}px;
    margin: 0 auto;

    @media screen and (min-width: ${MediaBreakpoint.MAX_PHONE}px) {
      max-width: 360px;
    }
  `,
}
